import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './email-template.action';

@Injectable({ providedIn: 'root' })
export class EmailTemplateTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                email_type: '',
                triggered_by_action: '',
                allowed_accesses: null,
                check_active: null,
                created_at: '', 
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'email_type';
    initialSortDirection = 'asc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    accesses = [];
    active_statuses = [];
    hasFilter = false;
    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'email_type', name: 'EMAIL_TEMPLATE.type', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'triggered_by_action', name: 'EMAIL_TEMPLATE.trigger-action', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'allowed_accesses', name: 'EMAIL_TEMPLATE.applies-to', sortable: false, hasFilter: true, filter: "select", options: 'accesses', options_id: "id", options_label: "name" },
                { prop: 'check_active', name: 'COMMON.status', sortable: false, hasFilter: true, filter: "select", options: 'active_statuses', options_id: "id", options_label: "name"},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            email_type: '', 
            triggered_by_action: '', 
            allowed_accesses: null, 
            check_active: '',
            created_at: '',
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}